let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("l5M0H")).then(() => parcelRequire('fOGtY'));